import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { notify } from 'uikit/Notifications';
import { useMutationCourseUpdate } from 'gql/mutations/course';
import extract from 'helpers/extract';
import { trackEvent, reportError } from 'lib/tracking';

import Code from './Code';

const CodeContainer = ({ course, ...props }) => {
  const { t } = useTranslation();
  const mutationCourseUpdate = useMutationCourseUpdate();
  const [isEditing, setEditing] = useState(false);
  const handleCopy = useCallback(() => {
    document.getElementById('share-code').select();
    document.execCommand('copy');
    notify('success', t('Course/Teacher/Cover/CourseShare/Code/code-copied'));
  }, [t]);
  const handleCodeMount = useCallback((ref) => {
    if (ref) {
      ref.select();
    }
  }, []);
  const handleCodeEdit = useCallback(() => {
    setEditing(true);
  }, []);
  const handleEditDone = useCallback(
    async (values, form) => {
      try {
        const accessCode = extract(
          values.accessCode,
          yup.string().trim().uppercase().required().min(1).max(256),
        );
        if (accessCode === course.accessCode) {
          setEditing(false);
          return;
        }
        await mutationCourseUpdate(course, {
          accessCode,
        });
        setEditing(false);
        trackEvent('course', 'update');
      } catch (err) {
        form.setStatus('500');
        reportError('course', 'update', err);
      }
    },
    [course, mutationCourseUpdate],
  );
  return (
    <Code
      course={course}
      handleCodeEdit={handleCodeEdit}
      handleCopy={handleCopy}
      handleEditDone={handleEditDone}
      handleCodeMount={handleCodeMount}
      isEditing={isEditing}
      t={t}
      {...props}
    />
  );
};

CodeContainer.propTypes = {
  course: PropTypes.object.isRequired,
};

export default CodeContainer;
